import axios from 'axios';

const url = process.env.REACT_APP_ENDPOINT_DEV;
const apiKey = process.env.REACT_APP_API_KEY_DEV;

export const APIRefundBookings = async (setLoading, refundData) => {
  // tripId, amount, refundReason, adminUserId
  setLoading(true);
  const result = await axios.post(
    `${url}/payment/manualRefund`,
    refundData,
    {
      headers: {
        'x-api-key': apiKey,
      },
    },
  ).catch((error) => error);
  return result;
};

export const APIGetAllBookings = async (
  setLoading,
  pageNumber,
  bookingsPerPage,
  searchString,
  from,
  to,
  status,
) => {
  setLoading(true);
  const result = await axios.get(`${url}/bookings`, {
    headers: {
      'x-api-key': apiKey,
    },
    params: {
      pageNumber,
      bookingsPerPage,
      searchString,
      from,
      to,
      status,
    },
  }).catch((error) => error);
  return result;
};

export const APIGetOperatorBookings = async (
  setLoading,
  pageNumber,
  bookingsPerPage,
  searchString,
  from,
  to,
  status,
  userOid,
  operatorOID,
) => {
  setLoading(true);
  const result = await axios.get(`${url}/bookings/admin`, {
    headers: {
      'x-api-key': apiKey,
    },
    params: {
      pageNumber,
      bookingsPerPage,
      searchString,
      from,
      to,
      status,
      userOid,
      ...(operatorOID && { operatorOID }),
    },
  }).catch((error) => error);
  return result;
};

// Get Zones

export const APIGetZones = async (setLoading) => {
  setLoading(true);
  try {
    const result = await axios.get(`${url}/zone`, {
      headers: {
        'x-api-key': apiKey,
      },
    });
    return result;
  } catch (error) {
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIGetAllCampaigns = async (setLoading, pageNumber, campaignsPerPage, status) => {
  setLoading(true);
  const result = await axios.get(`${url}/campaigns`, {
    headers: {
      'x-api-key': apiKey,
    },
    params: {
      page: pageNumber,
      totalPerPage: campaignsPerPage,
      status: status || undefined,
    },
  }).catch((error) => error);
  return result;
};

// called APIGetDriver
export const APIGetDriver = async (setLoading, role, userOid, operatorOID) => {
  setLoading(true);
  const result = await axios.get(`${url}/drivers`, {
    headers: {
      'x-api-key': apiKey,
    },
    params: {
      role,
      userOid,
      ...(operatorOID && { operatorOID }),
    },
  }).catch((error) => error);
  return result;
};

export const APIGetVehicle = async (setLoading, params, role, userOid, operatorOID) => {
  setLoading(true);
  const result = await axios.get(`${url}/vehicle`, {
    headers: {
      'x-api-key': apiKey,
    },
    params: {
      vehicleNumber: params && params.vehicleNumber,
      brand: params && params.brand,
      model: params && params.model,
      colour: params && params.colour,
      vehicleType: params && params.vehicleType,
      permitNumber: params && params.permitNumber,
      status: params && params.status,
      capacity: params && params.capacity,
      role,
      userOid,
      ...(operatorOID && { operatorOID }),
    },
  }).catch((error) => error);
  return result;
};

export const APIGetAdminUserAndPrivileges = async (setLoading, email) => {
  setLoading(true);
  const result = await axios.get(`${url}/adminUser`, {
    headers: { 'x-api-key': apiKey },
    params: { email },
  });
  setLoading(false);
  return result;
};

// get operator admin details
export const APIGetAdminUser = async (setLoading) => {
  setLoading(true);
  const result = await axios.get(`${url}/adminUsers`, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

// get operator admin assigments
export const APIGetOperatorAdminAssignment = async (setLoading) => {
  setLoading(true);
  const result = await axios.get(`${url}/operatorAdminAssignments`, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APIAdminFindUserByEmail = async (setLoading, emailOrPhone) => {
  setLoading(true);
  // Detect if input is email (contains @) or phone
  const isEmail = emailOrPhone && emailOrPhone.includes('@');
  const params = isEmail
    ? { email: emailOrPhone }
    : { phone: emailOrPhone };

  const result = await axios.get(`${url}/admin/users`, {
    headers: {
      'x-api-key': apiKey,
    },
    params,
  }).catch((error) => error);
  return result;
};

export const APIGetPassAssignments = async (setLoading, params = {}) => {
  setLoading(true);
  const result = await axios.get(`${url}/admin/users/passes`, {
    headers: {
      'x-api-key': apiKey,
    },
    params,
  }).catch((error) => error);
  return result;
};

export const APIFetchDigitalPasses = async (setLoading, params = {}) => {
  setLoading(true);
  const result = await axios.get(`${url}/digitalPass`, {
    headers: {
      'x-api-key': apiKey,
    },
    params,
  }).catch((error) => error);
  return result;
};

export const APICreateDigitalPass = async (setLoading, payload) => {
  setLoading(true);
  const result = await axios.post(`${url}/digitalPass`, payload, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APIAssignDigitalPass = async (setLoading, payload) => {
  setLoading(true);
  const result = await axios.post(`${url}/digitalPass/assign`, payload, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APIUnassignDigitalPass = async (setLoading, purchaseId) => {
  setLoading(true);
  const result = await axios.delete(`${url}/digitalPass/unassign/${purchaseId}`, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  setLoading(false);
  return result;
};

export const APIGetDigitalPass = async (setLoading, codeName) => {
  setLoading(true);
  const result = await axios.get(`${url}/digitalPass/${codeName}`, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APIUpdateDigitalPass = async (setLoading, codeName, passData) => {
  setLoading(true);
  const result = await axios.patch(`${url}/digitalPass/${codeName}`, passData, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

// called CreateDriver
export const APICreateDriver = async (setLoading, driverData) => {
  setLoading(true);
  const result = await axios.post(`${url}/driver/`, driverData, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APICreateVehicle = async (setLoading, vehicleData) => {
  setLoading(true);
  const result = await axios.post(`${url}/vehicle`, vehicleData, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APICreateUser = async (setLoading, userData) => {
  setLoading(true);
  const result = await axios.post(`${url}/adminUser`, userData, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APICreateOperator = async (setLoading, userData) => {
  setLoading(true);
  const result = await axios.post(`${url}/operators`, userData, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APICreateCampaign = async (setLoading, campaignData) => {
  setLoading(true);
  const result = await axios.post(`${url}/campaign`, campaignData, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APIPublishCampaign = async (setLoading, campaignId, targetAudience) => {
  setLoading(true);
  const result = await axios.post(`${url}/campaign/publish`, {
    campaignId,
    targetAudience: targetAudience || 'Everyone',
  }, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

// called Update
export const APIUpdateDriver = async (setLoading, driverId, driverData) => {
  setLoading(true);
  const result = await axios.patch(`${url}/driver/${driverId}`, driverData, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APIUpdateVehicle = async (setLoading, vehicleId, vehicleData) => {
  setLoading(true);
  const result = await axios.patch(`${url}/vehicle/${vehicleId}`, vehicleData, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APIUpdateUser = async (setLoading, userId, userData) => {
  setLoading(true);
  const result = await axios.patch(`${url}/adminUser/${userId}`, userData, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APIUpdateOperator = async (setLoading, operatorId, operatorData) => {
  setLoading(true);
  try {
    const result = await axios.patch(`${url}/operator/${operatorId}`, operatorData, {
      headers: {
        'x-api-key': apiKey,
      },
    });
    setLoading(false);
    return result;
  } catch (error) {
    setLoading(false);
    return error.response || error;
  }
};

export const APIAssignAdminOperator = async (setLoading, adminId, assignedOperators) => {
  setLoading(true);
  try {
    const result = await axios.patch(
      `${url}/assignAdmins/${adminId}`,
      {
        assignedOperators,
      },
      {
        headers: {
          'x-api-key': apiKey,
        },
      },
    );
    // console.log('APIAssignAdminOperator result:', result);
    setLoading(false);
    return result;
  } catch (error) {
    setLoading(false);
    return error.response || error;
  }
};

export const APIUpdateCampaign = async (setLoading, campaignId, campaignData) => {
  setLoading(true);
  const result = await axios.patch(`${url}/campaign/${campaignId}`, campaignData, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APIDeleteDriver = async (setLoading, driverId) => {
  setLoading(true);
  const result = await axios.delete(`${url}/driver/${driverId}`, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APIDeleteVehicle = async (setLoading, vehicleId) => {
  setLoading(true);
  const result = await axios.delete(`${url}/vehicle/${vehicleId}`, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APIDeleteUser = async (setLoading, userId) => {
  setLoading(true);
  const result = await axios.delete(`${url}/adminUser/${userId}`, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APIDeleteOperator = async (setLoading, operatorID) => {
  setLoading(true);
  const result = await axios.delete(`${url}/operator/${operatorID}`, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APIGetUsers = async (setLoading, status) => {
  setLoading(true);
  const result = await axios.get(`${url}/users`, {
    headers: {
      'x-api-key': apiKey,
    },
    params: {
      verificationStatus: status,
    },
  }).catch((error) => error);
  // console.log('result', result);
  return result;
};

export const APIGetOperator = async (setLoading) => {
  setLoading(true);
  const result = await axios.get(`${url}/operators`, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APIUpdateValidateUser = async (setLoading, userData) => {
  setLoading(true);
  const result = await axios.patch(`${url}/validateUser/`, userData, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

// Promo Codes API Functions

export const APIGetPromoCodes = async (setLoading, params = {}) => {
  setLoading(true);
  const result = await axios.get(`${url}/promoCodes`, {
    headers: {
      'x-api-key': apiKey,
    },
    params,
  }).catch((error) => error);
  return result;
};

export const APIGetPromoCode = async (setLoading, promoCodeName) => {
  setLoading(true);
  const result = await axios.get(`${url}/promoCodes/${promoCodeName}`, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};

export const APICreatePromoCode = async (setLoading, payload, role) => {
  setLoading(true);
  const result = await axios.post(`${url}/promoCodes`, payload, {
    headers: {
      'x-api-key': apiKey,
    },
    params: role ? { role } : {},
  }).catch((error) => error);
  return result;
};

export const APIUpdatePromoCode = async (setLoading, promoCodeName, payload, role, operatorOID) => {
  setLoading(true);
  const params = {};
  if (role) params.role = role;
  if (operatorOID) params.operatorOID = operatorOID;
  const result = await axios.patch(`${url}/promoCodes/${promoCodeName}`, payload, {
    headers: {
      'x-api-key': apiKey,
    },
    params,
  }).catch((error) => error);
  return result;
};

export const APIDeletePromoCode = async (setLoading, promoCodeName, role, operatorOID) => {
  setLoading(true);
  const params = {};
  if (role) params.role = role;
  if (operatorOID) params.operatorOID = operatorOID;
  const result = await axios.delete(`${url}/promoCodes/${promoCodeName}`, {
    headers: {
      'x-api-key': apiKey,
    },
    params,
  }).catch((error) => error);
  return result;
};

export const APIDeleteCampaign = async (setLoading, campaignId) => {
  setLoading(true);
  const result = await axios.delete(`${url}/campaign/${campaignId}`, {
    headers: {
      'x-api-key': apiKey,
    },
  }).catch((error) => error);
  return result;
};
